/* Recently viewed products.
   7 Oct 2026: the list in localStorage ("shopify-recent-view") used to grow forever, and every product page fetched a card
   for every product the visitor had ever opened (1,000+ requests for regular visitors). Now only the 12 most recently
   viewed products are kept and shown, older entries are trimmed from the saved list, and duplicates are removed.
   10 Oct 2026: the 12 card requests (each a full product page render) were sent as soon as the page loaded, competing with the
   page itself. They now start after the visitor has scrolled a third of the page, or 5 s after the page has loaded, whichever
   comes first. (The section itself is display:none until the cards arrive, so an IntersectionObserver cannot be used.) */
const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct ? recentViewdProduct.dataset.productHandle : "";
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";
var RECENT_VIEW_MAX = 12;

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  if (!recentViewdProduct) return;
  var productHandle = recentViewedProductHandle || false;
  if (!productHandle)
    return console.error(
      "[recentViewPorduct] Missing `data-product-handle` attribute. Failed to update the recentViewPorduct."
    );
  updaterecentViewPorduct(productHandle);

  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      window.removeEventListener("scroll", onScroll);
      recentViewsetupGrid(Recentgrid);
    };
    var onScroll = function () {
      var room = document.documentElement.scrollHeight - window.innerHeight;
      if (room <= 0 || window.scrollY > room / 3) start();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    var later = function () { setTimeout(start, 5000); };
    if (document.readyState === "complete") later();
    else window.addEventListener("load", later);
  }
});

var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct().filter(function (handle) {
    return handle !== recentViewedProductHandle;
  });
  if (recentViewPorduct.length > 0) {
    recentViewdProduct.classList.remove("no-js-inline");
  }

  var requestsRecentViewed = recentViewPorduct
    .slice(-RECENT_VIEW_MAX)
    .reverse()
    .map(function (handle) {
      var productTileTemplateUrl = "/products/" + encodeURIComponent(handle) + "?view=recent-view-card";
      return fetch(productTileTemplateUrl)
        .then(function (res) {
          return res.status == 200 ? res.text() : "";
        })
        .catch(function () {
          return "";
        });
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    Recentgrid.innerHTML = responses.join("");
  });
};

var getrecentViewPorduct = function () {
  var stored = "";
  try {
    stored = localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || "";
  } catch (e) {}
  var seen = {};
  var list = [];
  stored.split(LOCAL_STORAGE_DELIMITER).forEach(function (handle) {
    handle = handle.trim();
    if (handle && !seen[handle]) {
      seen[handle] = 1;
      list.push(handle);
    }
  });
  return list;
};

var setrecentViewPorduct = function (array) {
  var trimmed = array.slice(-(RECENT_VIEW_MAX + 1));
  var recentViewPorduct = trimmed.join(LOCAL_STORAGE_DELIMITER);
  try {
    if (trimmed.length) localStorage.setItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY, recentViewPorduct);
    else localStorage.removeItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY);
  } catch (e) {}
  return recentViewPorduct;
};

var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct().filter(function (h) {
    return h !== handle;
  });
  recentViewPorduct.push(handle);
  return setrecentViewPorduct(recentViewPorduct);
};

var recentViewPorductContains = function (handle) {
  return getrecentViewPorduct().indexOf(handle) !== -1;
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};
